export const configureMockupTour = [
  {
    target: '.tour-configure-mockup',
    content: 'Here you can generate a mockup to complete your order. Please fill in the size, color, image placement, and shipping details below to generate the mockup. Once the mockup is successfully generated, you can proceed to order. You can also see your generated mockups under the Mockups tab for later ordering.',
    placement: 'center',
  },
  {
    target: '.tour-print-options',
    content: 'Please fill all details including the shipping address to generate the mockup and calculate the actual cost including shipping.',
  },
  {
    target: '.tour-estimated-cost',
    content: 'The estimated price will become the actual price after generating the mockup, which includes the shipping cost based on your address and the selected image.',
  },
];